<template lang="pug">
v-container.pt-0(fill-height='', fluid='', grid-list-xl='')
    // Dialogs
    v-dialog(v-model='dialogPaySubscription' persistent='' :max-width="dialogMaxWidth")
      v-progress-linear(indeterminate='' color='green')
      v-card
        v-card-title.headline {{ dialogTitle }}
        v-card-text {{ dialogText }}

    v-dialog(v-model='showReferralCodeDialog' persistent='' max-width='400')
      v-card
        v-card-title.headline Código de referido
        v-card-text
          | {{ oldReferalOwnerCode ? 'Su código de referido actual es: ' + oldReferalOwnerCode : ''}} Si no desea introducir un código, presione en siguiente.
          v-text-field(label="Código de referido" @input="validateReferralCode" type="text" maxlength="6" v-model="referralCode")
          v-progress-circular(v-if="loadingReferralCode" class="align-self-end" size="20" indeterminate="" color="primary")
          v-icon(v-if="!loadingReferralCode && validCode && referralCode !== ''" class="align-self-center" color='green') mdi-check
          v-icon(v-if="!loadingReferralCode && !validCode && referralCode !== ''" class="align-self-center" color='red') mdi-close
          small(v-if="referralCode !== ''") {{ referralTextState }}
        v-card-actions
          v-spacer
          v-btn(color="red" @click="clickCancel") Cancelar
          v-btn(color="primary" @click="clickNext") Siguiente

    v-dialog(v-model='dialogCancel' persistent='' max-width='400px')
      v-progress-linear(v-if="banCancelProcess" indeterminate='' color='red')
      v-card
        v-card-title
          span.headline {{$t('payment.planner.cancelPlan')}}
        v-card-text
          v-container
            v-row
              p {{$t('payment.message.cancelPlan')}}
              v-textarea(v-bind:label="$t('payment.planner.reasonCancellation')" v-model="txtMotive")
        v-card-actions
          v-spacer
          v-btn(color='blue darken-1' text='' @click='dialogCancel = false') No
          v-btn(color='blue darken-1' text='' @click='cancelSubscription(currentIdSubscription)') Sí

    v-dialog(v-model='dialogCustomer' persistent='' max-width='400px')
      v-card
        v-card-title
          span.headline {{$t('payment.planner.customerData')}}
        v-card-text
          v-container
            v-row
              v-col(cols='12' sm='12' md='12')
                v-text-field(v-bind:label="$t('payment.user.name')" required='')
              v-col(cols='12' sm='12' md='12')
                v-text-field(v-bind:label="$t('payment.user.lastName')")
        v-card-actions
          v-spacer
          v-btn(color='blue darken-1' text='' @click='dialogCustomer = false') {{$t('payment.general.close')}}
          v-btn(color='blue darken-1' text='' @click='dialogCustomer = false') {{$t('payment.general.save')}}

    v-dialog(v-model='dialogCard' persistent='' max-width='700px')
      v-card
        v-card-title
          span.headline {{$t('payment.planner.adminCard')}}
        v-card-text
          v-row
            div(style="text-align: center;")
              p {{$t('payment.planner.infoCard')}}
            v-col(col="12" style="padding-top: 0px;")
              v-flex(md12='', style="padding-top: 0px;")
                v-row(style="padding-top: 0px;")
                v-progress-linear(v-if="banProgresBarCard" indeterminate='' color='teal')
                v-data-table.data-table-scroll(:headers='headers', :items='cardList', hide-default-footer='', :search='search')
                  template
                    v-card-text
                  template(v-slot:item.actions="{ item }")
                    v-tooltip(top='')
                      template(v-slot:activator='{ on }')
                        v-btn.main-btn(fab dark small v-on='on' @click="setMainCard(item)" v-show="item.mainCard != true")
                          v-icon(small) mdi-check
                      span {{$t('payment.planner.setMainCard')}}
                    v-tooltip(top='')
                      template(v-slot:activator='{ on }')
                        v-btn(fab dark small color='red' v-on='on' @click="cancelToken(item)" v-show="item.mainCard != true")
                          v-icon(small) mdi-delete
                      span {{$t('payment.planner.deleteCard')}}
                    p.p-main-card(v-if="item.mainCard == true") {{$t('payment.planner.mainCard')}}
        v-card-actions
          v-spacer
          v-btn(color='success' text='' @click='newCard') {{$t('payment.general.addNew')}}
          v-btn(color='blue darken-1' text='' @click='dialogCard = false') {{$t('payment.general.close')}}

    // Layout
    v-layout(wrap='')
      v-row
        v-col#divDataPlan.d-flex(cols="12" md="4" v-if="plan.title").px-0.pt-0
          v-card(style='width:100%').px-0
            v-card-title Plan seleccionado
            v-row
              v-col(cols='12' md='12').text-center
                v-btn(small @click="goBack").mx-2.hidden-xs-only
                  | {{$t('payment.planner.backPlans')}}
                  v-icon mdi-arrow-left-bold
            PagesPlanCardReduced(:plan="plan")

        v-col#divDataPayment.d-flex().px-0
          v-card(width='100%')
            template(v-if="!banViewCardData")
              v-progress-linear(v-if="banProgresBar" indeterminate='' color='teal')
              v-flex(md12='')
                v-col
                  v-row(cols='12')
                    v-row
                      v-col(md="12" style="padding: 0px 0px 0px 10px; text-align: center;")
                        p.card-title {{$t('payment.planner.membership')}}
                      v-col(md="12" style="padding: 0px 0px 0px 10px; text-align: center;")
                        v-skeleton-loader(mx-auto max-width='225' tile type='button' transition='scale-transition' v-if='loadingDataVerify && subscriptionsLst.length == 0 && currentPlan.description !== "Plan_Reactivate" && currentPlan.description !== "PERSONALIZADO"')
                        template(v-else)
                          v-card(v-for="subscription in subscriptionsLst" :key="subscription._id").mb-3
                            v-card-subtitle {{ subscription.plan.name }}
                            v-card-text
                              v-row
                                v-col(cols="6")
                                  p Period Start: {{ subscription.periodStart }}
                                v-col(cols="6")
                                  p Period End: {{ subscription.periodEnd }}
                                v-col(cols="6")
                                  p Next Verification Date: {{ subscription.nextVerificationDate }}
                                v-col(cols="6")
                                  p Status: {{ subscription.status }}
                                v-col(cols="6")
                                  p Amount: {{ subscription.plan.amount }} {{ subscription.plan.currency }}
                                v-col(cols="6")
                                  p Interval: {{ subscription.plan.interval }}
                                v-col(cols="12")
                                  v-btn.btn-suscribe.mx-5(color='green' small @click="subscribeNewPlan()" :loading="loadingNew" :disabled="loadingNew" v-if="subscription.status === 'canceled' || subscription.status === 'inactive'")
                                    | RENOVAR SUSCRIPCION
                                  v-btn.btn-suscribe.mx-5(color='red' small @click='dialogCancel = true' :loading="loadingNew" :disabled="loadingNew || profile.pendingPay" v-if="subscription.status === 'active'")
                                    | CANCELAR SUSCRIPCIÓN

                  v-row(md="4" sm="12" cols='12' style="text-align: center;")

                    v-flex(style="padding: 0px;")
                      p.card-title.font-weight-light {{$t('payment.planner.customerData')}}
                      v-row(style="padding: 0px;")
                        v-col(md="12" cols='12' style="padding: 0px 10px;")
                          v-text-field(v-model='completeName', v-bind:label="$t('payment.user.name')" required='' style="padding: 5px;" disabled=true)
                        v-col(md="12" cols='12' style="padding: 0px 10px;")
                          v-text-field(v-model='customer.email', v-bind:label="$t('payment.user.email')" required='' style="padding: 5px;" disabled=true)
                        v-col(md="12" cols='12' style="padding: 0px 10px;")
                          v-text-field(v-model='customer.phone', v-bind:label="$t('payment.user.phone')" required='' style="padding: 5px;" disabled=true)

                  v-row(md="4" sm="12" cols='12' style="text-align: center;")

                    v-flex(style="padding: 0px;")
                      p.card-title.font-weight-light {{$t('payment.planner.cardData')}}
                      v-row(style="padding: 0px;")
                        v-col(v-if="card.cardNumber" md="12" cols='12' style="padding: 0px 10px;")
                          v-text-field(v-model='card.cardNumber', v-bind:label="$t('payment.planner.cardNumber')" required='' style="padding: 5px;" disabled=true)
                        v-col(v-if="card.cardNumber" md="6" cols='12' style="padding: 0px 10px;")
                          v-text-field(v-model='card.cardYear', v-bind:label="$t('payment.planner.cardYear')" required='' style="padding: 5px;" disabled=true)
                        v-col(v-if="card.cardNumber" md="6" cols='12' style="padding: 0px 10px;")
                          v-text-field(v-model='card.cardBrand', v-bind:label="$t('payment.planner.cardBrand')" required='' style="padding: 5px;" disabled=true)
                        v-col(md="12" cols='12' style="padding: 0px 10px;")
                          v-btn(style="padding: 20px !important" color='green' @click.stop='dialogCard = true')
                            v-icon(small) mdi-pen
                            | {{$t('payment.general.update')}}

              v-row.justify-center
                v-col(cols="12").text-center
                  p {{ plan.heading }}

            // v-skeleton-loader.mx-auto(tile type='article' transition='scale-transition' v-if='banViewSubscriptionData && subscriptionsLst.length == 0 && currentPlan.description !== "Plan_Reactivate" && currentPlan.description !== "PERSONALIZADO"')
              v-col(col="12" md="12" v-if="banViewSubscriptionData && subscriptionsLst.length > 0")
                v-alert(v-if="profile.pendingPay" type="info") Estamos confirmando tu pago, mientras no podrás cambiar de plan pero sí puedes disfrutar de los beneficios de este.
                v-flex(md12='')
                  v-row
                    v-col
                      p.card-title.font-weight-light {{$t('payment.planner.subscriptionList')}}
                    v-col
                      v-spacer
                      v-text-field(v-model='search', append-outer-icon='mdi-search', v-bind:label="$t('payment.general.search')" single-line='' hide-details='')
                  v-data-table.data-table-scroll(:headers='headersSubscription', :items='subscriptionsLst', hide-default-footer='', :search='search')
                    template(v-slot:body="{ items }")
                      v-card-text
                    template(v-slot:item.actions="{ item }")
                      v-btn(style="padding: 10px !important" :loading="loadingCancel" color='red' @click="cancelSubsTable(item._id)" :disabled="item.status == 'canceled' || loadingCancel || profile.pendingPay")
                        v-icon(small) mdi-delete
                        | {{$t('payment.general.cancel')}}

            template(v-if="banViewCardData")
              credit-card-form(:plan="plan")

    v-snackbar(v-model='snackbar.snackbar' :color='snackbar.color' :center="true" :timeout='snackbar.timeout' :top="true")
      | {{ snackbar.text }}
      v-btn(dark='' text='' @click='snackbar.snackbar = false')
        | {{$t('payment.general.close')}}
</template>

<script>
  import PayMentService from '../../../plugins/payment/PaymentService'
  import axios from 'axios'
  import firebase from 'firebase'
  const paymentService = new PayMentService()

  export default {
    name: 'Planner',
    components: {
      PagesHeading: () => import('@/views/pages/components/Heading'),
      PagesPlanCard: () => import('@/views/pages/components/PlanCard'),
      PagesPlanCardReduced: () => import('@/views/pages/components/PlanCardReduced'),
      CreditCardForm: () => import('@/views/pages/components/CreditCardForm'),
    },
    props: {
      plan: {
        type: Object,
        default: () => ({
          best: false,
          heading: undefined,
          icon: undefined,
          title: undefined,
          text: undefined,
        }),
      },
    },
    data () {
      return {
        loadingDataVerify: false,
        loadingCancel: false,
        dialogPaySubscription: false,
        referralCode: '',
        resolve: null,
        referralTextState: '',
        showReferralCodeDialog: false,
        oldReferalOwnerCode: '',
        loadingReferralCode: false,
        validCode: false,
        invalidCodeMessage: false,
        shopsList: [],
        collaboratorsList: [],
        banCancelProcess: false,
        selectedIdSubscription: '',
        banProgresBarCard: false,
        currentToken: '',
        txtMotive: '',
        dialogCancelTable: false,
        dialogCancel: false,
        banButtonNew: false,
        loading: false,
        loadingNew: false,
        banProgresBar: true,
        snackbar: {
          color: '',
          snackbar: false,
          text: '',
          timeout: 6000,
        },
        currentPlan: {
          created: '',
          current_period_start: '',
          current_period_end: '',
          name: '',
          description: '',
          amount: '',
          interval: '',
          status_plan: '',
        },
        currentIdSubscription: '',
        currentIdPlan: '',
        currentIdCustomer: '',
        subscriptionsLst: [],
        monthList: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
        yearList: ['2020', '2021', '2022', '2023', '2024', '2025', '2026', '2027', '2028', '2029', '2030'],
        userRestrictions: {
          collaborators: 0,
          freeVirtualShopDays: 0,
          salePoints: 0,
          virtualShops: 0,
          active: false,
          trialDays: 0,
          dateFrom: null,
          dateUntil: null,
        },
        dialogCustomer: false,
        dialogCard: false,
        completeName: '',
        banViewCardData: false,
        banViewSubscriptionData: false,
        localIp: '',
        search: '',
        cardList: [],
        tokenEpayco: undefined,
        docType: {},
        card: {
          cardNumber: '',
          cardYear: '',
          cardMonth: '',
          cardName: '',
          cardMail: '',
          cardCvv: '',
          cardBrand: '',
          cadCCDocument: '',
        },
        customer: {
          token_card: '',
          name: '',
          last_name: '',
          email: '',
          default: true,
          phone: '',
        },
        headers: [
          {
            sortable: true,
            text: this.$t('payment.planner.cardNumber'),
            value: 'data.card.mask',
            align: 'left',
          },
          {
            sortable: true,
            text: this.$t('payment.planner.creationDate'),
            value: 'data.token.created',
            align: 'left',
          },
          {
            sortable: true,
            text: this.$t('payment.planner.cardBrand'),
            value: 'data.card.name',
            align: 'left',
          },
          {
            sortable: false,
            text: this.$t('payment.general.actions'),
            value: 'actions',
            align: 'left',
          },
        ],
        headersSubscription: [
          {
            sortable: true,
            text: this.$t('payment.planner.planName'),
            value: 'idPlan',
            align: 'left',
          },
          {
            sortable: true,
            text: this.$t('payment.planner.planStatus'),
            value: 'status',
            align: 'left',
          },
          {
            sortable: true,
            text: this.$t('payment.planner.planAmount'),
            value: 'plan.amount',
            align: 'left',
          },
          {
            sortable: false,
            text: this.$t('payment.general.actions'),
            value: 'actions',
            align: 'left',
          },
        ],
      }
    },
    computed: {
      plan_reactivate () {
        return this.$store.state.payment.plan_reactivate
      },
      changeRestrictions () {
        return this.$store.state.payment.restrictions
      },
      profile () {
        return this.$store.getters['users/getProfile']
      },
      dialogMaxWidth () {
        return this.plan.id_plan !== 'Plan_Reactivate' ? '290' : '350'
      },
      dialogTitle () {
        return this.plan.id_plan !== 'Plan_Reactivate' ? 'Procesando pago' : 'Actualizando suscripción'
      },
      dialogText () {
        return this.plan.id_plan !== 'Plan_Reactivate'
          ? 'Se está procesando su pago del servicio. Por favor espere un momento. Gracias.'
          : 'Por favor espere mientras se genera la suscripción...'
      },
    },
    watch: {
      changeRestrictions () {
        this.getDataSubscription()
      },
    },
    mounted () {
      this.initData()
    },
    methods: {
      async initData () {
        try {
          this.shopsList = this.$store.getters['shops/getItems']
          this.collaboratorsList = await this.$store.dispatch('users/getCollaborators')
          const element = document.getElementById('divDataPayment')
          element.classList.add(this.plan.title ? 'col-md-8' : 'col-md-12')
          await this.getIpAddress()
          await this.initializePaymentSession()
          await this.getCardData()
          await this.getDataSubscription()
          await this.getDataSubscriptions()
          if (this.$store.state.users.profile.referralOwnerCode) {
            const code = await this.$store.dispatch('referrals/getCodeOfReferralOwner', this.$store.state.users.profile.referralOwnerCode)
            if (code) {
              this.oldReferalOwnerCode = code
            }
          }
        } catch (error) {
          console.error(error)
        }
      },
      async getIpAddress () {
        try {
          const response = await axios.get('https://api.ipify.org?format=json')
          this.localIp = response.data.ip
        } catch (error) {
          console.error('Error fetching IP address:', error)
        }
      },
      async initializePaymentSession () {
        try {
          const token = await paymentService.initSesionCard()
          this.tokenEpayco = token
          localStorage.setItem('token', this.tokenEpayco)
        } catch (error) {
          console.error('Error initializing payment session:', error)
        }
      },
      async validateReferralCode () {
        if (this.referralCode.length === 6) {
          this.loadingReferralCode = true
          this.invalidCodeMessage = false
          this.referralTextState = 'Verificando código'
          const referralObj = {
            userId: this.$store.state.users.user.uid,
            referralCode: this.referralCode.toUpperCase(),
            action: 'add',
            subaction: 'validate',
          }
          try {
            const res = await this.$store.dispatch('referrals/codeValidator', referralObj)
            if (res && res !== this.$store.state.users.user.uid) {
              this.validCode = true
              this.referralTextState = 'Código válido'
            } else {
              this.validCode = false
              this.invalidCodeMessage = true
              this.referralTextState = 'Código inválido'
            }
          } catch (error) {
            this.validCode = false
            this.invalidCodeMessage = true
            this.referralTextState = 'Código inválido'
          } finally {
            this.loadingReferralCode = false
          }
        } else {
          this.loadingReferralCode = false
          this.validCode = false
          this.invalidCodeMessage = true
          this.referralTextState = 'Código inválido'
        }
      },
      async subscribeNewPlan () {
        if (!this.plan.title) {
          this.setDataNotification(true, 'error', this.$t('payment.message.selectedPlan'))
          return
        }

        try {
          const confirmRes = await this.$confirm(this.$t('payment.message.newPlan'))
          if (!confirmRes) return

          const referralCodeRes = await this.referralCodeQuestion()
          if (!referralCodeRes) return

          this.loadingNew = true
          this.dialogPaySubscription = true

          const dataSubscription = {
            id_subscription: this.currentIdSubscription,
            txtMotive: this.$t('payment.message.planUpdate'),
            shops: this.shopsList,
            collaborators: this.collaboratorsList,
          }

          const cancelRes = await this.$store.dispatch('payment/cancelSubscription', dataSubscription)
          if (!cancelRes || !cancelRes.status) {
            this.setDataNotification(true, 'error', this.$t('payment.message.errorCancelSubscription'))
            this.loadingNew = false
            return
          }

          const dataNewSubscription = {
            id_plan: this.plan.id_plan,
            restrictions: this.plan.restrictions,
            shops: this.shopsList,
            collaborators: this.collaboratorsList,
          }

          if (this.plan.id_plan === 'Plan_Reactivate') {
            await this.createReactivateSubscription()
          } else {
            await this.createNewSubscription(dataNewSubscription)
          }
        } catch (error) {
          this.setDataNotification(true, 'error', this.$t('payment.message.errorProcessSubscription'))
          this.loadingNew = false
        }
      },
      async createReactivateSubscription () {
        await this.$store.dispatch('payment/createSubscription', {
          id_plan: this.plan.id_plan,
          restrictions: this.plan.restrictions,
          shops: this.shopsList,
          collaborators: this.collaboratorsList,
        })

        const currentUser = firebase.auth().currentUser
        await this.$store.dispatch('users/saveRestrictions', {
          uid: currentUser.uid,
          restrictions: this.plan.restrictions,
        })

        this.loading = false
        this.dialogPaySubscription = false
        this.loadingNew = false
        await this.getDataSubscriptions()
        await this.getDataSubscription()
        this.setDataNotification(true, 'success', this.$t('payment.message.successProcess'))
        // window.location.href = 'https://admin-tender.web.app/#/dashboard/profile'
      },
      async createNewSubscription (dataNewSubscription) {
        const createRes = await this.$store.dispatch('payment/createSubscription', dataNewSubscription)
        if (!createRes || !createRes.status) {
          this.setDataNotification(true, 'error', this.$t('payment.message.errorProcessSubscription'))
          this.loadingNew = false
          return
        }

        const dataSubscription = {
          doc_number: this.card.cadCCDocument,
          doc_type: this.docType.value || 'CC',
          ip: this.localIp,
          id_plan: this.plan.id_plan,
          shops: this.shopsList,
          collaborators: this.collaboratorsList,
        }

        const currentUser = firebase.auth().currentUser
        await this.$store.dispatch('users/saveRestrictions', {
          uid: currentUser.uid,
          restrictions: this.userRestrictions,
        })

        const payRes = await this.$store.dispatch('payment/paySubscription', dataSubscription)
        this.loading = false
        this.dialogPaySubscription = false

        if (payRes && payRes.status === 'active') {
          await this.handlePaymentSuccess(payRes)
          // console.log("PAYRES success", payRes);
        } else {
          this.setDataNotification(true, 'error', this.$t('payment.message.errorProcessCard'))
          await this.getDataSubscriptions()
          await this.getDataSubscription()
          // console.log("PAYRES", payRes);
          // window.location.href = 'https://admin-tender.web.app/#/dashboard/profile'
        }
      },
      async handlePaymentSuccess (payRes) {
        await this.getDataSubscriptions()
        await this.getDataSubscription()
        if (payRes.status === 'active') {
          this.setDataNotification(true, 'success', this.$t('payment.message.successProcess'))
        } else if (payRes.status === 'canceled') {
          this.setDataNotification(true, 'error', this.$t('payment.message.errorProcessCard'))
        } else {
          this.setDataNotification(true, 'warning', this.$t('payment.message.inactiveSubscription'))
        }
        // console.log("PAYRES 2", payRes);
        // window.location.href = 'https://admin-tender.web.app/#/dashboard/profile'
      },
      setDataNotification (ban, color, text) {
        this.snackbar.snackbar = ban
        this.snackbar.color = color
        this.snackbar.text = text
      },
      goBack () {
        this.$router.push('Plans')
      },
      async getDataSubscription () {
        try {
          this.loadingDataVerify = true
          const data = {
            shops: this.shopsList,
            collaborators: this.collaboratorsList,
          }
          const res = await this.$store.dispatch('payment/getSubscriptionData', data)
          this.banButtonNew = true
          this.loadingDataVerify = false
          if (res.status) {
            if (res.data.idClient === 'Plan_Reactivate' && this.plan.id_plan === 'Plan_Reactivate') {
              this.banViewCardData = false
            }
            this.loading = false
            this.loadingNew = false
            this.banViewSubscriptionData = true
            this.currentPlan.created = res.data.createdAt.substring(0, 10)
            this.currentPlan.current_period_start = res.data.createdAt.substring(0, 10)
            this.currentPlan.current_period_end = res.data.createdAt.substring(0, 10)
            this.currentPlan.name = res.data.description
            this.currentPlan.description = res.data.idClient
            this.currentPlan.amount = res.data.amount
            this.currentPlan.interval = res.data.interval === 'month' ? this.$t('payment.general.month') : res.data.interval
            this.currentPlan.status_plan = res.status.val
            this.currentIdSubscription = res.id
            this.currentIdPlan = res.data.idClient
          } else {
            this.banViewSubscriptionData = false
          }
        } catch (error) {
          console.error(error)
        }
      },
      async getDataSubscriptions () {
        try {
          const res = await this.$store.dispatch('payment/getSubscriptionsData')
          this.banProgresBar = false

          if (res) {
            this.subscriptionsLst = res.array
          }
        } catch (error) {
          console.error(error)
        }
      },
      async getCardData () {
        try {
          const res = await this.$store.dispatch('payment/getCardData')
          if (res && res.card && res.person && res.token) {
            this.card.cardNumber = res.card ? res.card.mask : ''
            this.card.cardYear = res.card ? res.card.exp_year : ''
            this.card.cardMonth = res.card ? res.card.exp_month : ''
            this.card.cardBrand = res.card ? res.card.name : ''
            this.card.cardName = res.person.holderName ? res.person.holderName : ''
            this.card.cardMail = res.person.emailUser ? res.person.emailUser : ''
            this.card.cadCCDocument = res.person.doc_number
            this.docType = res.person.doc_type.name || 'Cedula de ciudadanía'
            this.currentToken = res.token.id
          }
          await this.getCustomerData()
        } catch (error) {
          console.error(error)
        }
      },
      async getCustomerData () {
        try {
          const res = await this.$store.dispatch('payment/getCustomerData')
          if (res) {
            this.customer.token_card = '********'
            this.customer.name = res.dataCustomer.name
            this.customer.last_name = res.dataCustomer.name
            this.customer.email = res.dataCustomer.email
            this.banViewCardData = false
            this.completeName = this.$store.state.users.profile.name + ' ' + this.$store.state.users.profile.last_name
            this.customer.phone = this.$store.state.users.profile.phone
            this.currentIdCustomer = res.dataCustomer.customerId
            this.cardList = res.cardList.reverse()

            this.cardList.forEach(card => {
              card.mainCard = card.data.card.mask === this.card.cardNumber
            })
            // console.log(this.cardList)
          } else if (this.plan.id_plan === 'Plan_Reactivate') {
            this.completeName = this.$store.state.users.profile.name + ' ' + this.$store.state.users.profile.last_name
            this.customer.phone = this.$store.state.users.profile.phone
            this.customer.email = this.$store.state.users.user.email
          } else {
            this.cardList = []
            this.banViewCardData = true
          }
        } catch (error) {
          console.error(error)
        }
      },
      cancelSubsTable (idSelect) {
        this.dialogCancelTable = true
        this.selectedIdSubscription = idSelect
      },
      async cancelSubscription (idSubscription) {
        try {
          this.loadingCancel = true
          this.banCancelProcess = true
          if (this.txtMotive !== '') {
            const dataSubscription = {
              id_subscription: idSubscription,
              txtMotive: this.txtMotive,
              shops: this.shopsList,
              collaborators: this.collaboratorsList,
            }
            const res = await this.$store.dispatch('payment/cancelSubscription', dataSubscription)
            this.banCancelProcess = false
            this.dialogCancel = false
            this.dialogCancelTable = false
            this.loadingCancel = false
            if (res && res.status) {
              const dataNewSubscription = {
                id_plan: this.plan_reactivate.data.id_plan,
                restrictions: this.plan_reactivate.data.restrictions,
                shops: this.shopsList,
                collaborators: [],
              }
              await this.$store.dispatch('payment/createSubscription', dataNewSubscription)
              const currentUser = firebase.auth().currentUser
              await this.$store.dispatch('users/saveRestrictions', {
                uid: currentUser.uid,
                restrictions: this.plan.restrictions,
              })
              await this.getDataSubscriptions()
              await this.getDataSubscription()
              this.setDataNotification(true, 'success', this.$t('payment.message.successProcess'))
              // console.log("res 0", res);
              // window.location.href = 'https://admin-tender.web.app/#/dashboard/profile'
            }
          } else {
            this.setDataNotification(true, 'error', this.$t('payment.message.reasonCancel'))
          }
        } catch (error) {
          this.setDataNotification(true, 'error', this.$t('payment.message.errorCancelSubscription'))
          this.loadingCancel = false
        }
      },
      paySubscription () {
        this.$confirm(this.$t('payment.message.payConfirmMessage')).then(async res => {
          if (res) {
            const referralRes = await this.referralCodeQuestion()
            if (referralRes) {
              this.loading = true
              this.dialogPaySubscription = true
              const dataSubscription = {
                doc_number: this.card.cadCCDocument,
                doc_type: this.docType.value || 'CC',
                ip: this.localIp,
                id_plan: this.currentIdPlan,
                shops: this.shopsList,
                collaborators: this.collaboratorsList,
              }
              const currentUser = firebase.auth().currentUser
              await this.$store.dispatch('users/saveRestrictions', {
                uid: currentUser.uid,
                restrictions: this.userRestrictions,
              })
              const payRes = await this.$store.dispatch('payment/paySubscription', dataSubscription)
              this.dialogPaySubscription = false
              this.loading = false
              if (payRes && payRes.success) {
                await this.handlePaymentSuccess(payRes)
              } else {
                this.setDataNotification(true, 'error', this.$t('payment.message.errorProcessCard'))
                await this.getDataSubscriptions()
                await this.getDataSubscription()
              }
            }
          }
        })
      },
      async setMainCard (item) {
        this.banProgresBarCard = true
        try {
          const confirmRes = await this.$confirm(this.$t('payment.message.mainCardConfirmMessage'))
          if (confirmRes) {
            item.data.customerId = this.currentIdCustomer
            const res = await this.$store.dispatch('payment/setMainCard', item.data)
            if (res) {
              this.banProgresBarCard = false
              await this.getCardData()
              this.setDataNotification(true, 'success', this.$t('payment.message.successMainCardMessage'))
            }
          }
        } catch (error) {
          this.banProgresBarCard = false
          this.setDataNotification(true, 'error', this.$t('payment.message.errorMainCardMessage'))
          this.loadingNew = false
        }
      },
      async cancelToken (item) {
        this.banProgresBarCard = true
        try {
          const confirmRes = await this.$confirm(this.$t('payment.message.cancelCardConfirmMessage'))
          if (confirmRes) {
            const dataCancel = {
              franchise: item.data.card.name,
              mask: item.data.card.mask,
              id_card: item.id,
            }
            const res = await this.$store.dispatch('payment/cancelToken', dataCancel)
            if (res && res.status) {
              this.banProgresBarCard = false
              await this.getCustomerData()
              this.setDataNotification(true, 'success', this.$t('payment.message.succesCancelCardMessage'))
            } else {
              this.setDataNotification(true, 'error', this.$t('payment.message.errorCancelCardMessage'))
              this.banProgresBarCard = false
            }
          }
        } catch (error) {
          this.setDataNotification(true, 'error', this.$t('payment.message.errorCancelCardMessage'))
          this.banProgresBarCard = false
        }
      },
      newCard () {
        this.dialogCard = false
        this.$router.push('/dashboard/NewCard')
      },
      referralCodeQuestion () {
        return new Promise(resolve => {
          this.showReferralCodeDialog = true
          this.resolve = resolve
        })
      },
      clickNext () {
        if (this.validCode) {
          const referralObj = {
            userId: this.$store.state.users.user.uid,
            referralCode: this.referralCode.toUpperCase(),
            action: 'add',
            subaction: 'cancelSuscrpAndPayAgain',
          }
          this.$store.dispatch('referrals/codeValidator', referralObj).then(() => {
            this.showReferralCodeDialog = false
            this.resolve(true)
          })
        } else {
          this.showReferralCodeDialog = false
          this.resolve(true)
        }
      },
      clickCancel () {
        this.showReferralCodeDialog = false
        this.resolve(false)
      },
    },
  }
</script>

<style lang="scss" scoped>
  .p-main-card {
    padding-top: 10px;
    color: green;
    font-weight: bold;
  }
  .main-btn {
    background-color: gray !important;
  }
  .main-btn:hover {
    background-color: #3a8038 !important;
  }
  .data-table-scroll {
    max-height: 300px;
    overflow: auto;
  }
  .btn-suscribe {
    font-size: 1.4rem;
    max-width: 90vw;
    @media (max-width: 900px) {
      font-size: 1rem;
    }
  }
</style>
